import * as NavigationMenu from '@radix-ui/react-navigation-menu';
import { ACTIVE_CLASS_NAME, NAVBAR_VARIANTS } from 'modules/nav/constants';
import styled, { css } from 'styled-components';
import {
  body2,
  colors,
  duration,
  easing,
  fontWeights,
  largeShadow,
  spacing,
  zIndex,
} from 'ui/theme';

export const Root = styled(NavigationMenu.Root)`
  display: flex;
  flex-grow: 1;
  > :first-child {
    flex-grow: 1;
  }
`;

export const List = styled(NavigationMenu.List)`
  display: flex;
  padding: 0;
  margin: 0;
  gap: ${spacing.half};
`;

/**
 * Transparent pseudo content used to maintain a hover state between the navbar button and the content dropdown
 * Spacing values equal padding between button and li, and the offset in Content margin-top
 */
const hoverStateSpacer = css`
  &::before {
    content: "";
    position: absolute;
    top: -${spacing.base};
    left: 0;
    height: ${spacing.base};
    width: 100%;
  }
`;

export const Content = styled(NavigationMenu.Content)`
  position: absolute;
  top: calc(100% + ${spacing.quarter});
  left: 0;
  z-index: ${zIndex.dropdown};
  display: flex;
  width: ${spacing.x24};
  flex-direction: column;
  gap: ${spacing.half};
  padding: ${spacing.threeQuarter};
  background-color: ${colors.white};
  border-radius: ${spacing.half};
  ${largeShadow}
  ${hoverStateSpacer}

  &[data-content="min"] {
    width: max-content;
    min-width: ${spacing.x12};
    max-width: ${spacing.x16};
  }
`;

export const Item = styled(NavigationMenu.Item)`
  position: relative;
  display: block;
  padding-top: ${spacing.threeQuarter};
  padding-bottom: ${spacing.threeQuarter};
  transition-duration: 0.5s;

  &::before {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: ${spacing.quarter};
    border-radius: ${spacing.quarter} ${spacing.quarter} 0 0;
  }

  &.${ACTIVE_CLASS_NAME} {
    &::before {
      background-color: ${colors.purple100};
    }
  }
`;

export const Trigger = styled(NavigationMenu.Trigger)`
  padding: ${spacing.fiveEights} ${spacing.threeQuarter};
  border-radius: ${spacing.double};
  ${body2};
  color: ${colors.textSecondary};
  font-weight: ${fontWeights.semiBold};
  border: none;
  background-color: ${colors.white};
  transition: all ${duration.short} ${easing.standard};

  &[data-variant=${NAVBAR_VARIANTS.NOVA}] {
    background-color: transparent;
    box-shadow: none;
  }

  &:hover,
  ${Item}:hover & {
    background-color: ${colors.grey10};
  }

  &:focus {
    outline: 2px solid ${colors.green50};
  }

  .${ACTIVE_CLASS_NAME} > & {
    color: ${colors.purple100};

    &:hover {
      background-color: ${colors.purple10};
    }
  }

  ${`.${ACTIVE_CLASS_NAME}`}:hover > & {
    background-color: ${colors.purple10};
  }
`;
